<div class="comparison__body">
  @if (title) {
    <div class="comparison__title">
      <h2 class="text-center">{{ title }}</h2>
    </div>
  }

  <div class="comparison__container">
    <div class="comparison__wrapper">
      @for (comparisonProduct of comparisonProducts; track comparisonProduct; let i = $index) {
        <div class="comparison__item">
          <div class="comparison__item-image">
            <!-- FIXME: Currently using non-null assertion (.asset!) which assumes 'asset' is always present.
            This can fail if contentful is configured incorrectly, but it is not a problem for now
            -->
            <img
              [src]="
                comparisonProduct.productVariants.length > 0
                  ? comparisonProduct.productVariants[0].mainAsset.fields.asset!.fields.file?.url
                  : comparisonProduct.mainAsset.fields?.asset?.fields?.file
              "
              [alt]="comparisonProduct.mainAsset.fields?.alternateText"
              [id]="'img_' + i"
            />
          </div>
          <div class="comparison__item-data">
            <div class="comparison__item-title">{{ comparisonProduct.shortTitle }}</div>
            @if (showPrices && comparisonProduct.productESWInfo) {
              <div class="comparison__item-price">
                <app-product-price
                  [feedId]="comparisonProduct.productESWInfo.v4ApiResponse.feedID"
                  [showPercentage]="false"
                  [productPriceInfo]="comparisonProduct.productESWInfo.price"
                  [showDiscounted]="false"
                  [showFromPriceText]="showFromPriceText"
                />
              </div>
            }
            <app-bazaarvoice
              class="comparison__item-bv"
              [bvProductId]="comparisonProduct | extractBazaarvoiceID: 'ContentfulComparisonProduct'"
              [isInline]="true"
            />
            @if (comparisonProduct.showPurchaseButton) {
              <a
                class="comparison__item-button btn btn-primary"
                [ngClass]="{ disabled: comparisonProduct.deactivateBuyNowButton || !comparisonProduct.product_id }"
                [routerLink]="['/product', comparisonProduct.product_id]"
              >
                {{ comparisonProduct.buyNowLabel }}
              </a>
            }
            <div class="comparison__selector_wrapper">
              <div class="comparison__selector-title" i18n="@@product.select_color">Color</div>
              <div class="comparison__selector-options" [id]="'comparison__selector-' + comparisonProduct.id">
                @for (variant of comparisonProduct.productVariants; track variant; let iVariant = $index) {
                  <div class="comparison__sphere-color" [ngClass]="{ active: iVariant === 0 }">
                    <button
                      type="button"
                      class="comparison__sphere_selector"
                      [ngStyle]="getGradient(variant.color)"
                      (click)="changeImage(i, variant, iVariant, comparisonProduct.id)"
                      (keypress)="changeImage(i, variant, iVariant, comparisonProduct.id)"
                    >
                      @if (variant.color) {
                        <div class="sr-only">{{ variant.color.name }}</div>
                      }
                      @if (!variant.color) {
                        <div class="sr-only">Color</div>
                      }
                    </button>
                    @if (variant.color) {
                      <div class="comparison__sphere-color-name" [innerHTML]="formatColorOptions(variant?.color?.name)"></div>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="comparison__item-options">
              <ul class="">
                @for (option of comparisonProduct.options; track option) {
                  <li [innerHTML]="getOptions(option)"></li>
                }
              </ul>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
